import React from 'react';

const ArrowRight = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 7 12" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="ArrowRight_a" d="M572 803.36l1.32-1.36 5.68 5.83-5.68 5.84-1.32-1.36 4.35-4.48z" />
    </defs>
    <use fill="currentColor" xlinkHref="#ArrowRight_a" transform="translate(-572 -802)" />
  </svg>
);

export default ArrowRight;



// WEBPACK FOOTER //
// ./src/common/icons/ArrowRight.js